/** The company providing shipment tracking */
export enum TrackingPlatform {
  EASYPOST = "easypost",
  TRACK123 = "track123",
  FIRST_MILE = "first_mile",
  UPS = "ups",
  LANDMARK_GLOBAL = "landmark_global",
  ETA_EXPRESS = "eta_express",
  CROSSBORDERLY = "crossborderly",
  DUMMY = "dummy",
  GLOBALE = "globale",
  NZ_POST = "nz_post",
  WWEX = "wwex",
  DHL_ECS = "dhl_ecs",
}
